import styled from 'styled-components';

import { defaultColor, radius, spacing } from 'styles/theme';

export const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: ${spacing('medium')};
  border-radius: ${radius('extraSmall')};
  background: ${defaultColor('green', 0.12)};
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing('large')};
`;
